import { NoopScrollStrategy } from '@angular/cdk/overlay';
import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app-services/auth-service/auth.service';
import { UserService } from '@app-services/user/user.service';
import { ClassService } from 'src/app/core/services/class.service';
import { CourseService } from 'src/app/core/services/course.service';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { CommonDialogComponent } from '../common-dialog/common-dialog.component';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { TenantConstant } from '@app-constants/tenant.constant';
import { openLoginForm } from 'src/app/helpers/methods';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { FirebaseAnalyticsService } from '@app-services/firebase-analytics/firebase-analytics.service';
import * as moment from 'moment';
import {DatePipe} from '@angular/common';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscribeActiveComponent } from '../subscribe-active/subscribe-active.component';
import { SubscribemodalComponent } from '../subscribemodal/subscribemodal.component';
import { isUserAdmin} from '@app-helpers/functions';
import { FirebaseService } from '@app-services/firebase/firebase.service';
@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.css'],
})
export class CustomButtonComponent implements OnInit, OnChanges {
  @Input() cta: any = null;
  @Input() fromLiveClassPage: boolean;
  public omsdevapi=environment.omsdevapi
  public LIVE_CLASS_API=environment.LIVE_CLASS_API;
  tenant: any = TenantConstant.tenant;
  isAuthenticated: boolean = false;
  userData: any;
  userFromLocal:any;
  openLoginForm = openLoginForm;
  isButtonDisabled: boolean = true;
  omsPackageInfo: any;
  omsRespObj:any ={
    oms_userdto_course:null,
    isSubExpired:null,
    isExpiredByStatus:null
  };
  isJoinButtonDisabled: boolean = false;
  oms_userdto_course: any;
  componentInstance: any;
  omsMatchedPack: any;
  tempcourse: any;
  wasAttendedByStd: Boolean=false;
  mySubscriptionList: any;
  prodBranch = environment.branch;
  isUserLoggedInAsAdmin: boolean= false;
  constructor(
    private authService: AuthService,
    public _eventHandlingService: EventHandlingService,
    private classService: ClassService,
    private currenRoute: ActivatedRoute,
    private courseService: CourseService,
    private router: Router,
    private eventHandlingService: EventHandlingService,
    private userService: UserService,
    private dialog: MatDialog,
    private gaService: GAnalyticsService,
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private http:HttpClient,
    public modalservice: NgbModal,
    private firebaseService: FirebaseService,
  ) { }

  ngOnInit(): void {
      this.userFromLocal=JSON.parse(
        localStorage.getItem(apisDataCacheKeys.userDetails)
      );
    this.authService.isAuth.subscribe((isAuth) => {
      this.isAuthenticated = isAuth;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const _propName in changes) {
      if (changes.hasOwnProperty(_propName)) {
        switch (_propName) {
          case 'cta':
            if (changes.cta.currentValue) {
              let _cta = Object.assign({}, changes.cta.currentValue);
              if (_cta.type === 'rewatch' || _cta.type === 'teacherRewatch') {
                if (
                  _cta?.data?.recording &&
                  _cta?.data?.recording != undefined &&
                  Array.isArray(_cta.data.recording) &&
                  _cta?.data?.recording?.length > 0
                  &&
                  _cta?.data?.allowRecordedClassVisibility
                ) {
                  this.isButtonDisabled = false;
                } else {
                  this.isButtonDisabled = true;
                }
              } else if (_cta.type === 'teacherJoinNow' && _cta.isDisabled) {
                this.isButtonDisabled = true;
              } else {
                this.isButtonDisabled = false;
              }
            } else {
              this.cta = null;
            }
            break;
        }
      }
    }
  }

sendData(){
  let payload;
    payload={
      data:{
      live_class:'enrolled',
      subject: this.cta.data.subject,
      chapter:this.cta.data.obj.name,
      educator_name:this.cta.data.teacher.name
    },
    landingPage : "LSQ_CUSTOM_EVENTS"
    };

    let  firebasePayload = {
      "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      "ActivityEvent": 262,
      "Fields":{},
      "FirstName": this.userData?.firstName,
      "LastName": this.userData?.lastName,
      "environment": environment?.branch,
      "phone": this.userData?.phone,
      "productId": 1,
      "type": "Activity"
    }
  isUserAdmin(this.userService).then((bool) => {
    if(!bool) {
      // this.userService.callTrackingAPI2(this.userFromLocal.userId, payload,'Act_Master_Class_Web').subscribe((data)=>{console.log(data);
      // });

      this.firebaseService.getSqsValue().then((firebaseRSP) => {
        firebasePayload.Fields = {
          mx_Custom_2:'enrolled',
          mx_Custom_4: this.cta.data.subject,
          mx_Custom_5:this.cta.data.obj.name,
          mx_Custom_8:this.cta.data.teacher.name
        }
        this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
      }).catch((e) => {
        console.log(e);
      });
    }
  })
}
  async clickAction() {
    this.loadUser();
    if (this.isAuthenticated) {
      if (this.cta.type == 'register') {
        this.registerClass(this.cta);
        this.sendData();
        if (this.cta) {
          this.gaService.webEngageEvent({
            'event': 'Register Live Class',
            'grade': this.cta?.data.grade[0],
            'date': new Date(String(this.datePipe.transform(this.cta?.data?.schedule?.startDate, 'yyyy-MM-ddTHH:mm:ss'))),
            'subject': this.cta?.data?.subject,
            'topic': this.cta?.data?.title,
            'teacher': this.cta?.data?.teacher?.name,
            'Class type': this.cta?.data?.obj?.classtype,
          })
        }
      } else if (this.cta.type == 'joinnow') {
        if (this.cta) {
          this.gaService.webEngageEvent({
            'event': 'Live Class Started',
            'grade': this.cta?.data.grade[0],
            'date': new Date(String(this.datePipe.transform(this.cta?.data?.schedule?.startDate, 'yyyy-MM-ddTHH:mm:ss'))),
            'subject': this.cta?.data?.subject,
            'topic': this.cta?.data?.title,
            'teacher': this.cta?.data?.teacher?.name,
            'Class type': this.cta?.data?.obj?.classtype,
          })
        }

        if (this.cta.data.isRegisteredForClass) {
         await this.verifyCourse(this.userData?.userId,this.userData?.grade)
        } else {
          this.isJoinButtonDisabled = true;
          const _eclassId = this.cta.data.id;
          this.classService
            .classRegistre(
              _eclassId,
              this.tenant == 'infinitylearn'
                ? this.userData?.userId
                : this.userData?.userId
                ? this.userData.userId
                : localStorage.getItem('studentid')
            )
            .subscribe(
              async (res: any) => {
                await this.verifyCourse(this.userData?.userId,this.userData?.grade)
              },
              (err: any) => {
              }
            );
        }
      } else if (
        this.cta.type == 'rewatch' ||
        this.cta.type === 'teacherRewatch'
      ) {
        if (this.cta) {
          this.gaService.webEngageEvent({
            'event': 'Class Rewatch',
            'grade': this.cta?.data.grade[0],
            'Date': this.cta?.data?.schedule?.startDate,
            'Time': this.cta?.data?.schedule?.startDate,
            'subject': this.cta?.data?.subject,
            'topic': this.cta?.data && this.cta?.data?.obj && this.cta?.data?.obj?.chapterMeta ? this.cta?.data?.obj?.chapterMeta[0]?.topics[0]?.topicName : '',
            'teacher': this.cta?.data?.teacher?.name,
            'Class type': this.cta?.data?.obj?.classtype,
          })

          if(this.cta?.type =="rewatch"){
           await isUserAdmin(this.userService).then(res=>this.isUserLoggedInAsAdmin = res? true:false).catch(err=>this.isUserLoggedInAsAdmin = false)
            if(!this.isUserLoggedInAsAdmin && this.cta?.data?.subscription =='paid'){
              if(!this.cta?.data?.isRecordedClass){
              this.http.get(`${this.LIVE_CLASS_API}students/rewatchAccess?class=${this.cta?.data?.id}&student=${this.userData?.userId}`).subscribe(res=>{
                if(JSON.parse(JSON.stringify(res)).data){
                  this.wasAttendedByStd = true;
                }else{
                  this.wasAttendedByStd = false;
                }
              })
            }else{
              this.wasAttendedByStd = false;
            }
              this.http.get(`${this.omsdevapi}userorders/mySubscription?grade=${this.userData?.grade}&userId=${this.userData?.userId}`).subscribe(resp=>{
              let omsresponse:any =resp
              this.tempcourse = this.cta?.data?.course?._id ? this.cta?.data?.course?._id:this.cta?.data?.course
              let omsMatchedPack;
              if (omsresponse) {
                this.omsPackageInfo = omsresponse.map(
                  (pack) =>  {
                    if(!this.cta.data.isRecordedClass){
                      this.mySubscriptionList =  pack?.mySubcriptionDtoList?.filter(subcourse=> this.tempcourse ==subcourse?.userOrderPackageSubscriptionsDto?.courseId)
                    }else{
                      this.mySubscriptionList =  pack?.mySubcriptionDtoList?.filter(subcourse=> subcourse?.userOrderPackageSubscriptionsDto?.recordedCourseList.some(crs_btch=>  crs_btch?.courseId==this.cta.data.course))
                    }
                    if(this.mySubscriptionList?.length==1){
                      this.omsRespObj.isSubExpired = this.mySubscriptionList[0]?.userOrderPackageSubscriptionsDto?.expired
                    }
                    return this.mySubscriptionList
                  }
                )
                this.omsPackageInfo = this.omsPackageInfo?.filter(validPack=>validPack?.length>0)
              }
              if (this.omsPackageInfo?.length > 0) {
                this.oms_userdto_course = !this.cta.data.isRecordedClass ?
                this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.courseId :
                this.cta?.data?.course
                let courseExpireDate = moment(
                  new Date(
                    this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.expiryDate
                  )
                ).unix();
                let courseDates = this.omsPackageInfo?.flat()?.map(v=>{
                  return ( moment(new Date(v?.userOrderPackageSubscriptionsDto?.expiryDate)).unix()) > moment().unix() ? false : true
                })
                this.omsRespObj.isExpiredByStatus = courseDates.every(v=>v)
                // this.omsRespObj.isExpiredByStatus =
                //   courseExpireDate > moment().unix() ? false : true; //this is Bagali code commented for now PI-282 can be recorrected
              }

              if(!this.oms_userdto_course){
                this.checkSrcTypeAndNavigate(this.cta.data);

               }else if(this.tempcourse?.toString() ===this.oms_userdto_course?.toString() && !this.omsRespObj?.isSubExpired ){

                  if(!this.omsRespObj.isExpiredByStatus){
                    this.checkSrcTypeAndNavigate(this.cta.data);
                  }else if(!this.omsRespObj.isExpiredByStatus &&this.wasAttendedByStd){
                    this.checkSrcTypeAndNavigate(this.cta.data);
                  }else{
                    this.componentInstance = this.modalservice.open(SubscribemodalComponent,{
                      centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
                    })
                    this.spinner.hide();

                  }
                }else{
                  if(this.omsRespObj.isExpiredByStatus){
                    this.componentInstance = this.modalservice.open(SubscribemodalComponent,{
                      centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
                    })
                    this.spinner.hide();
                    return
                  }else if(this.omsRespObj.isSubExpired &&!this.omsRespObj.isExpiredByStatus && !this.wasAttendedByStd){
                    this.componentInstance = this.modalservice.open( SubscribeActiveComponent,{
                      centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
                    })
                    this.spinner.hide();
                    return
                  }else{
                    this.checkSrcTypeAndNavigate(this.cta.data);
                  }
                }
              })
            }else{
              this.checkSrcTypeAndNavigate(this.cta.data);
            }
          }else{
            this.checkSrcTypeAndNavigate(this.cta.data);
          }
        }
      } else if (this.cta.type == 'enroll') {
        if (this.fromLiveClassPage) {
          let string = '`${this.redirectUrl}`';
          let classObj = this.cta.data;
          this.firebaseService.getFireBaseEventUserDetailsPromise().then((val:any)=>{
            let firebaseObj = {
              platform: val?.platform,
              grade: val?.grade,
              stream:val?.stream,
              board:val?.board,
              exams: val?.exams,
              exam: val?.exam,
              state:val?.state,
              city:val?.city,
              imageUrl:classObj?.batchPicture?.[0],
              courseName:classObj?.title,
              classLanguage:classObj?.language,
              subjects:classObj?.obj?.subjects.join(','),
            };
            this.firebaseAnalyticsService.postEvent("web_liveclass_cta_enrollNow",firebaseObj);
          })
        }
        this.gaService.webEngageEvent({
          'event': 'Recommend Course',
          'grade': this.cta?.data?.grade,
          'hours': this.cta?.data?.duration,
          'language': this.cta?.data?.language,
          'subjects': this.cta?.data?.subjects?.toString(),
          'Course name': this.cta?.data?.title
        })
       await isUserAdmin(this.userService).then(res=>this.isUserLoggedInAsAdmin =res?  true:false).catch(err=>this.isUserLoggedInAsAdmin = false)
        if (!this.isUserLoggedInAsAdmin && (this.cta?.data?.subscription?.toLowerCase() == 'paid'||this.cta?.data?.courseCommercial =="paid")) {
          let data = { ...this.cta?.data };
          if (this.cta?.data?.hasOwnProperty('courseDetail')) {
            data = { ...this.cta?.data?.courseDetail };
          }
          if(data.exams.indexOf(/CBSE/)!=-1){
            data.exams.splice(/CBSE/,1,'CBSE')
          }else{
            data.exams.forEach(element => {
              if(data.exams.indexOf(/CBSE/) != -1 ){
                data.exams.splice(element.indexOf(/CBSE/),1,"CBSE")
              }else if(data.exams instanceof Array && data.exams.length>1 && element.includes('CBSE')){
                data.exams.push('CBSE')
              }else if(data.exams instanceof Array && data.exams.length==1 && element.includes('CBSE')){
                data.exams = ['CBSE']
              }
              data.exams = [...new Set(data.exams)]
            });
          }
          this.router.navigate(['/subscription/subscriptionPackages'], {
            state: { ...data },
          });
        } else {
          if (this.cta.dataType == 'batch') {
            this.cta.data.courseDetail.schedule.startDate =
            this.cta.data.courseDetail.batchId = this.cta.data.id;
            this.cta.data.startDate;
            this.cta.data = this.cta.data.courseDetail;
          }
          this.cta.data.dataType = this.cta.dataType;
          this.courseService.enrollCourse(this.cta.data).subscribe(
            (res: any) => {
              if (
                (res && res.statusCode == 200) ||
                (res && res.statusCode == 201)
              ) {
                const config: MatDialogConfig = {
                  data: this.cta.data,
                  scrollStrategy: new NoopScrollStrategy(),
                  disableClose: true,
                };
                const dialogRef = this.dialog.open(
                  CommonDialogComponent,
                  config
                );
              }
            },
            (err) => {
            }
          );
        }
      } else if (this.cta.type?.toLowerCase() == 'viewcourse') {
        if (this.cta.dataType == 'myCourse') {
          const objdata={
            'course':this.cta?.data?.title
          }
          let state= {
            data:this.cta?.data,
            filter:this.cta?.filter
          }
          this.firebaseAnalyticsService.postEvent("user_course",objdata);
          if (this.router.url.includes('/dashboard/my-courses')) {
            localStorage.setItem('from-my-course-page', 'true');
          }
          this.courseService.courseData.next(state);
          this.router.navigateByUrl(`/mycourse/${this.cta.data.id}`,{state});
        } else if (this.cta.dataType == 'allCourse') {
          this.router.navigateByUrl(`/course/${this.cta.data.id}`);
        }
      } else if (this.cta.type == 'teacherViewSession') {
        this.router.navigateByUrl(`/classes/view-session/${this.cta.data.id}`);
      } else if (this.cta.type == 'teacherJoinNow') {
        localStorage.setItem('leaveUrl', window.location.href);
        this.router.navigateByUrl(`/classes/view-session/${this.cta.data.id}`);
        window
          .open(
            `/live-class/${this.cta.data.id}/teacher-live-class/${this.cta.data.meeting.id}`,
            '_blank'
          )
          .focus();
      }
    } else {
      this.login();
    }
  }

  get isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }

  dispatchEventStudentJoinClass(){
    let crntUserDetails = this.userService.getMobileAndName();
    let data = {
      userId: crntUserDetails.userId, 
      classId: this.cta.data.id, 
      status: 'join'
    }
    this.classService.studentJoinLeftSession(data).subscribe((res) => console.log(res));
  }

  joinLiveClass = () => {
      if(this.cta.data.classSource?.type =='youtube'){
        localStorage.setItem('ytLink', this.cta.data.classSource?.url);
        this.setLocalStorageForClass()
        this.dispatchEventStudentJoinClass();
        this.router.navigateByUrl('selfLearn-V2/ytVideos');
        return;
      }
    localStorage.removeItem('class-time-spent');
    const _eclassId = this.cta.data.id;
    var _errMsg = '';
    this.classService.getClassDetails(_eclassId).subscribe(
      (res: any) => {
        const _classDetails = Object.assign({}, res.data);

        if (Array.isArray(_classDetails.meeting)) {
          _classDetails.meeting = Object.assign({}, _classDetails.meeting[0]);
        }

        let serverTime = localStorage.getItem('serverTime');
        let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
        let _crntTime = Math.round(new Date(current_time).getTime() / 1000);

        if (
          Object.keys(_classDetails.meeting).length > 0 &&
          _classDetails?.meeting?.id != undefined
        ) {
          if (_classDetails.meeting.status == 'ended') {
            _errMsg =
              'Class already ended. Please check your past classes to rewatch';
            this.showActionErrorMsg(_errMsg);
            setTimeout(() => {
              window.location.reload();
            }, 1000)
          }
          else if (
            _classDetails.startDate > _crntTime ||
            _classDetails.meeting.status == 'waiting' ||
            _classDetails.meeting.status == 'teacher_started'
          ) {
            localStorage.setItem('leaveUrl', window.location.href);
            window
              .open(
                `/live-class/${_eclassId}/waiting-class/${_classDetails.meeting.id}`,
                '_blank'
              )
              .focus();
          } else if (_classDetails.startDate < _crntTime) {
            if (_classDetails.meeting.status == 'started') {
              localStorage.setItem('leaveUrl', window.location.href);
              const url = `/live-class/${_eclassId}/student-live-class/${_classDetails.meeting.id}`;
              window.location.href = url;
            }
          }
        } else {
          _errMsg = 'Unable to join live class! Please try again';
          this.showActionErrorMsg(_errMsg);
        }
        this.isJoinButtonDisabled = false;
        this._eventHandlingService.changeClassStatus('loaddata');
      },
      (err: any) => {
        this.isJoinButtonDisabled = false;
        _errMsg = 'Unable to join live class! Please try again';
        this.showActionErrorMsg(_errMsg);
      }
    );
  };

  checkSrcTypeAndNavigate(data){
    if(data.classSource?.type =='youtube' ){
      localStorage.setItem('ytLink', data.classSource?.url);
      localStorage.setItem('channelName', data.chatChannelName);
      localStorage.setItem('classId', this.cta.data.id);
      localStorage.setItem('isFromJoinClass', 'false');
      let navigateUrl =environment.branch!='staging' || data.classSource.meetingType=='live' ?'selfLearn-V2/ytVideos' : `/live-class/${this.cta.data.id}/ytrewatch`
        this.router.navigate([navigateUrl]);
      
    }else{
      this.router.navigate([`/live-class/${this.cta.data.id}/rewatch`]);
    }
  }

  showActionErrorMsg = (_msg: string = '') => {
    const config: MatDialogConfig = {
      data: { msg: _msg },
      scrollStrategy: new NoopScrollStrategy(),
    };
    this.dialog.open(ErrorDialogComponent, config);
  };

  login() {
    this.openLoginForm(this.cta);
  }

  loadUser(): void {
    this.userData = this.userService.getMobileAndName();
  }

  registerClass(event: any) {
    this.loadUser();
    if (event?.data) {
      this.gaService.webEngageEvent({
        'event': 'Register Live Class',
        'grade': this.cta?.data.grade[0],
        'date': new Date(String(this.datePipe.transform(this.cta?.data?.schedule?.startDate, 'yyyy-MM-ddTHH:mm:ss'))),
        'subject': this.cta?.data?.subject,
        'topic': this.cta?.data?.title,
        'teacher': this.cta?.data?.teacher?.name,
        'Class type': this.cta?.data?.obj?.classtype,
      })
      this.firebaseAnalyticsService.postEvent("activation_live_reg");
    }

    this.classService
      .classRegistre(
        event?.data?.id,
        this.tenant == 'infinitylearn'
          ? this.userData?.userId
          : this.userData?.userId
            ? this.userData.userId
            : localStorage.getItem('studentid')
      )
      .subscribe(
        (res: any) => {
          const config: MatDialogConfig = {
            width: '439px',
            data: event.data,
            scrollStrategy: new NoopScrollStrategy(),
          };
          const dialogRef = this.dialog.open(RegisterDialogComponent, config);
          dialogRef.afterClosed().subscribe(() => {
            this.eventHandlingService.updateChangeAction({});
            this.eventHandlingService.changeClassStatus('loaddata');
          });
        },
        (err: any) => {
        }
      );
  }

  async verifyCourse(studentId,studentGrade):Promise<any>{
    await isUserAdmin(this.userService).then(res=>this.isUserLoggedInAsAdmin =res? true:false).catch(err=>this.isUserLoggedInAsAdmin = false)
    if (!this.isUserLoggedInAsAdmin && this.cta?.data?.subscription == 'paid') {
      this.http.get(`${this.LIVE_CLASS_API}students/rewatchAccess?class=${this.cta.data.id}&student=${studentId}`).subscribe(res=>{
        if(JSON.parse(JSON.stringify(res)).data){
          this.wasAttendedByStd = true;
        }else{
          this.wasAttendedByStd = false;
        }
      })
    this.http
    .get(
      `${this.omsdevapi}userorders/mySubscription?grade=${this.userData.grade}&userId=${this.userData?.userId}`
    )
    .subscribe((resp) => {
      let omsresponse: any = resp;
      this.tempcourse = this.cta?.data?.course._id ? this.cta?.data?.course._id:this.cta?.data?.course
      if (omsresponse) {
        this.omsPackageInfo = omsresponse.map(
          (pack) =>  {

            this.mySubscriptionList =  pack?.mySubcriptionDtoList?.filter(subcourse=> this.tempcourse ==subcourse?.userOrderPackageSubscriptionsDto?.courseId)
            if(this.mySubscriptionList?.length==1){
              this.omsRespObj.isSubExpired = this.mySubscriptionList?.[0]?.userOrderPackageSubscriptionsDto?.expired
            }
            return this.mySubscriptionList
          }
        )
        this.omsPackageInfo = this.omsPackageInfo?.filter(validPack=>validPack?.length>0)
      }
      if (this.omsPackageInfo?.length > 0) {
        this.oms_userdto_course =
        this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.courseId
        // let courseExpireDate = moment(
        //   new Date(
        //     this.omsPackageInfo[0][0]?.userOrderPackageSubscriptionsDto?.expiryDate
        //   )
        // ).unix();
   
        // this.omsRespObj.isExpiredByStatus =
        //   courseExpireDate > moment().unix() ? false : true;
        let courseExpireDates =  this.omsPackageInfo?.flat()?.map(v=> moment(
          new Date(
            v?.userOrderPackageSubscriptionsDto?.expiryDate
          )
        ).unix())
        this.omsRespObj.isExpiredByStatus =  courseExpireDates.map(v=>v> moment().unix() ? false : true).every(v=>v)
      }
      if (!this.oms_userdto_course) {

        this.joinLiveClass();
      } else if (
          this.tempcourse?.toString() ===
          this.oms_userdto_course?.toString() &&
          !this.omsRespObj?.isSubExpired
          ) {
            if (!this.omsRespObj?.isExpiredByStatus) {
              this.joinLiveClass();
            } else {
              this.componentInstance = this.modalservice.open(
                SubscribemodalComponent,
                {
                  centered: true,
                  size: 'sm',
                windowClass: 'subscription-modal-custom',
              }
              );
              this.spinner.hide();
            }
          } else {
            if(this.omsRespObj.isExpiredByStatus){
              this.componentInstance = this.modalservice.open(SubscribemodalComponent,{
                centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
              })
              this.spinner.hide();
              return
            }else{
              this.componentInstance = this.modalservice.open(
                SubscribeActiveComponent,
                {
                  centered: true,
                  size: 'sm',
                  windowClass: 'subscription-modal-custom',
                }
                );
                this.spinner.hide();
              }
            }
          });
        } else {

          this.joinLiveClass();
        }
  }

  setLocalStorageForClass(){
    localStorage.setItem('ytLink', this.cta.data.classSource?.url);
    localStorage.setItem('channelName', this.cta.data.chatChannelName);
    localStorage.setItem('classId', this.cta.data.id);
    localStorage.setItem('isFromJoinClass', 'true');
  }
}
